import { useEffect, useState } from "react";
import { api, fmtUsd, fmtTimeAgo } from "@/lib/nexus";
import { AlertTriangle } from "lucide-react";

export default function AlertsPanel({ compact = false }) {
  const [alerts, setAlerts] = useState([]);
  useEffect(() => {
    api.get("/alerts").then((r) => setAlerts(r.data.items));
  }, []);

  return (
    <div className="panel brackets">
      <span className="b1" /><span className="b2" />
      <div className="px-3 py-2 border-b border-nexus-border flex justify-between items-center">
        <div className="panel-title"><span className="dot" style={{ background: "#FF3366", boxShadow: "0 0 8px #FF3366" }} />Anomaly Alerts</div>
        <span className="text-[10px] font-mono text-nexus-rose">{alerts.filter((a) => a.severity === "critical").length} CRITICAL</span>
      </div>
      <div className={compact ? "max-h-[280px] overflow-auto" : "overflow-auto"}>
        {alerts.map((a) => {
          const border = a.color === "rose" ? "border-nexus-rose/60" : "border-nexus-amber/50";
          const text = a.color === "rose" ? "text-nexus-rose" : "text-nexus-amber";
          return (
            <div
              key={a.id}
              data-testid={`alert-${a.id}`}
              className={`px-3 py-2.5 border-l-2 ${border} border-b border-nexus-border/60 hover:bg-nexus-panel-2/40`}
            >
              <div className="flex items-start gap-2">
                <AlertTriangle size={14} className={`${text} mt-0.5 shrink-0 ${a.severity === "critical" ? "animate-pulse" : ""}`} />
                <div className="min-w-0 flex-1">
                  <div className="flex justify-between items-center gap-2">
                    <div className={`font-rajdhani uppercase tracking-widest text-[12px] font-semibold ${text}`}>{a.title}</div>
                    <span className="text-[10px] font-mono text-nexus-text-3 shrink-0">{fmtTimeAgo(a.timestamp)}</span>
                  </div>
                  <div className="text-[11px] text-nexus-text-2 mt-0.5">{a.description}</div>
                  <div className="mt-1.5 flex justify-between text-[10px] font-mono">
                    <span className="text-nexus-text-2">Target: <span className="text-nexus-cyan">{a.agent_name}</span> · {a.framework} · {a.chain}</span>
                    <span className={text}>impact {fmtUsd(a.impact_usd)}</span>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
